import React, { FC } from 'react';

import { colorOpacity } from 'theme';

import { Tag } from 'components/index';

const formatType = (type: string) =>
  type
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, character => character.toUpperCase());

export const SummaryCountTag: FC<{
  type: string;
  total: number;
  color: string;
}> = ({ type, total, color }) => (
  <Tag
    label={`${total} ${formatType(type)}${total !== 1 ? 's' : ''}`}
    styles={{
      label: { color },
      tag: {
        w: 'fit-content',
        bg: colorOpacity(color, 0.1),
        border: 'none',
        borderRadius: 'full',
        display: 'inline-flex',
        py: 0.5,
        px: 3,
        m: 0.5,
      },
    }}
  />
);
